import { writable } from 'svelte/store';
const htmlFragmentLoaderContentHolderDisplayedUrl = new Map();
export function getHtmlFragmentLoaderForTargetIdIfExists(targetId) {
    if (htmlFragmentLoaderContentHolderDisplayedUrl.has(targetId)) {
        return { isPresent: true, data: htmlFragmentLoaderContentHolderDisplayedUrl.get(targetId) };
    }
    return { isPresent: false };
}
export function getHtmlFragmentLoaderForTargetId(targetId) {
    if (!htmlFragmentLoaderContentHolderDisplayedUrl.has(targetId)) {
        htmlFragmentLoaderContentHolderDisplayedUrl.set(targetId, writable());
    }
    return htmlFragmentLoaderContentHolderDisplayedUrl.get(targetId);
}
export function cleanUpHtmlFragmentLoaderForTargetId(targetId) {
    htmlFragmentLoaderContentHolderDisplayedUrl.delete(targetId);
}
